import Toolbar from "@mui/material/Toolbar";
import Head from "next/head";
import Script from "next/script";
import { usePostHog } from "posthog-js/react";
import React, { Fragment, useEffect } from "react";
import { useDispatch } from "react-redux";
import EmployerLanding from "../../components/employer/EmployerLanding/EmployerLanding";
import ToResolveClassNameError from "../../components/hoc/ToResolveClassNameError";
import EmployerNavbar from "../../components/shared/SharedNavbar/Navbar/EmployerNavbar";
import * as config from "../../config/config";
import { updateContactUsEmployer } from "../../redux/actions/dialog_action";

function Employer(props) {
  const posthog = usePostHog();
  const dispatch = useDispatch();

  const posthogHideELPPostForFree =
    posthog.getFeatureFlag("elp-hide-post-for-free") == "hide-navbar";
  const isELPPostion = posthogHideELPPostForFree ? "hidden" : "shown";

  useEffect(() => {
    localStorage.setItem("posthogPosition", "bottom_promo");
    localStorage.setItem("posthogImage", isELPPostion);
    localStorage.setItem("posthogRegisterELP", "false");
  }, []);

  useEffect(() => {
    const params = new URL(window.location.href).searchParams;
    const utms = {};
    for (const [key, value] of params.entries()) {
      utms[key] = value;
    }
    if (Object.keys(utms).length) {
      localStorage.setItem("utm_params", JSON.stringify(utms));
    }

    const requestDemo = params.get("request_demo");

    if (requestDemo == "true") {
      dispatch(
        updateContactUsEmployer({
          state: true,
          origin: "employer_landing",
        })
      );
    }
  }, []);

  let metaTitle =
    "Job Posting & Headhunting | All In 1 Recruitment Site - Hiredly Malaysia";
  let metaDescription =
    "Hire mid-management and junior talent on Hiredly. Easy, Fast, Value for Money. Reach out to more candidate at an affordable price with quality service.";

  // useTawkToEffect();
  return (
    <Fragment>
      <Head>
        <title>{metaTitle}</title>
        <meta name="title" content={metaTitle} />
        <meta name="description" content={metaDescription} />

        {/* <!-- Open Graph / Facebook --> */}
        <meta property="og:type" content="website" key={"ogType"} />
        <meta
          property="og:url"
          content="https://my.hiredly.com/employer"
          key="ogUrl"
        />
        <meta property="og:title" content={metaTitle} key="ogTitle" />
        <meta
          property="og:description"
          content={metaDescription}
          key="ogDescription"
        />
        <meta
          property="og:image"
          content={
            config.assetDomain + "/images/hiredly/hiredly-meta-image-v1.png"
          }
          key="ogImage"
        />

        {/* <!-- Twitter --> */}
        <meta
          property="twitter:card"
          content="summary_large_image"
          key="twitterCard"
        />
        <meta
          property="twitter:url"
          content="https://my.hiredly.com/employer"
          key="twitterUrl"
        />
        <meta property="twitter:title" content={metaTitle} key="twitterTitle" />
        <meta
          property="twitter:description"
          content={metaDescription}
          key="twitterDescription"
        />
        <meta
          property="twitter:image"
          content={
            config.assetDomain + "/images/hiredly/hiredly-meta-image-v1.png"
          }
          key="twitterImage"
        />
        <meta
          name="viewport"
          content="minimum-scale=1, initial-scale=1, width=device-width"
        />
        <link rel="canonical" href="https://my.hiredly.com/employer" />
      </Head>

      {/* Respond.io WhatsApp Widget Script*/}
      <Script
        id="respondio__growth_tool"
        src={`https://cdn.respond.io/widget/widget.js?wId=${config.respondIOWidgetId}`}
        strategy="lazyOnload"
      />

      <ToResolveClassNameError>
        <EmployerNavbar />
        <Toolbar />
      </ToResolveClassNameError>
      <EmployerLanding />
    </Fragment>
  );
}

export default Employer;
